import styled from "@emotion/styled";

export const ContentBeforeContainer = styled("div")<{
    isContentBeforeVisible?: boolean;
}>`
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 40px;
    margin-top: -1px;
`;
